import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api/axios";
import MainLayout from "../layoutpage/MainLayout";
import Footer from "../../components/Footer";

export default function UnitDetailsBooking({ user, onLogout }) {
  user = JSON.parse(localStorage.getItem("user"));
  const { bookingId } = useParams();
  const [bookingDetails, setBookingDetails] = useState(null);
  const navigate = useNavigate();

  const fetchBooking = async () => {
    try {
      const res = await api.get(`/api/bookings/${bookingId}`);
      console.log("Single Booking Initial", res.data.data);
      setBookingDetails(res.data.data);
    } catch (error) {
      console.log("Single Booking error", error);
    }
  };

  useEffect(() => {
    fetchBooking();
  }, [bookingId]);

  // Photo helper function
  const getUnitPhotoUrl = (unit) => {
    if (!unit?.photos || !Array.isArray(unit.photos) || unit.photos.length === 0) {
      return null;
    }
    const photo = unit.photos.find((p) => p.is_primary) || unit.photos[0];
    if (photo.file_path.startsWith("http")) {
      return photo.file_path;
    }
    return `${api.defaults.baseURL}/${photo.file_path}`;
  };

  if (!bookingDetails) return <p className="p-6">Loading...</p>;

  const handlePayment = (method) => {
    // navigate(`/payment/${bookingDetails.id}`, {
    //   state: { bookingDetails, method },
    // });
    if (method === "cash") {
      console.log("Single Booking Record", bookingDetails);
      navigate(`/payment/${bookingDetails.id}`, {
        state: { bookingDetails, method },
      });
    }
  };

  return (
    <>
      <div
        className="container d-flex justify-content-center align-items-center min-vh-100"
        style={{
          paddingLeft: window.innerWidth > 768 ? "280px" : "15px",
        }}
      >
        <div
          className="card shadow-lg p-5 rounded-4"
          style={{ maxWidth: "600px", width: "100%" }}
        >
          {/* Title */}
          <h2 className="text-center fw-bold mb-4">
            {bookingDetails.property.name}
          </h2>
          <h4
            className="text-center  mb-4"
            style={{ textDecoration: "underline" }}
          >
            {bookingDetails.unit.unit_number}
          </h4>
          {/* Unit Image */}
          <div className="mb-4">
            {getUnitPhotoUrl(bookingDetails.unit) ? (
              <>
                <img
                  src={getUnitPhotoUrl(bookingDetails.unit)}
                  alt={bookingDetails.unit.unit_number}
                  className="img-fluid rounded shadow-sm"
                  style={{
                    height: "350px",
                    width: "100%",
                    objectFit: "cover",
                    border: "1px solid #ddd",
                  }}
                />
                {bookingDetails.unit.photos && bookingDetails.unit.photos.length > 1 && (
                  <div className="row g-2 mt-2">
                    {bookingDetails.unit.photos.slice(0, 4).map((photo, index) => (
                      <div key={photo.id || index} className="col-3">
                        <img
                          src={photo.file_path.startsWith("http")
                            ? photo.file_path
                            : `${api.defaults.baseURL}/${photo.file_path}`}
                          alt={`unit photo ${index + 1}`}
                          className="img-fluid rounded cursor-pointer"
                          style={{
                            height: "60px",
                            width: "100%",
                            objectFit: "cover",
                            border: "1px solid #eee",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <div
                className="d-flex align-items-center justify-content-center bg-light border rounded"
                style={{
                  height: "350px",
                  width: "100%",
                }}
              >
                <span className="text-muted">No Photo Available</span>
              </div>
            )}
          </div>

          {/* Details List */}
          <ul className="list-group list-group-flush mb-4 fs-5">
            <li className="list-group-item d-flex justify-content-between">
              <strong>Price:</strong>
              <span className="text-success fw-bold">
                ৳ {bookingDetails.unit.price}
              </span>
            </li>
            {/*  Unit Size */}
            <li className="list-group-item d-flex justify-content-between">
              <strong>Unit Size:</strong>
              <span>
                {bookingDetails.property.area_sq_ft}{" "}
                {bookingDetails.unit?.measurement[0]?.unit_of_measure}
              </span>
            </li>
            {/* Facilities */}
            <li className="list-group-item d-flex justify-content-between">
              <strong>Facillities:</strong>
              <span>
                {bookingDetails.unit.facilities &&
                  bookingDetails.unit.facilities.join(", ")}{" "}
              </span>
            </li>

            {/* Minimum Payable */}
            <li className="list-group-item d-flex justify-content-between">
              <strong>Minimum Payable:</strong>
              <span className="text-primary fw-bold">
                ৳ {bookingDetails.unit.price * 0.1}
              </span>
            </li>
            {/* paid amount */}
            <li className="list-group-item d-flex justify-content-between">
              <strong>Paid Amount:</strong>
              <span className="text-primary fw-bold">
                ৳ {bookingDetails.paid_amount}
              </span>
            </li>
            {/* Due amount */}
            <li className="list-group-item d-flex justify-content-between">
              <strong>Due Amount:</strong>
              <span className="text-danger fw-bold">
                ৳ {bookingDetails.due_amount ?? "No Due"}
              </span>
            </li>
          </ul>

          {/* Buttons */}
          <div className="d-flex justify-content-center gap-3 mt-3">
            <button
              className="btn btn-pink px-4 py-2"
              style={{ background: "#d63384", color: "white" }}
              onClick={() => handlePayment("bkash")}
            >
              bKash
            </button>

            <button
              className="btn btn-warning px-4 py-2 text-white"
              style={{ background: "#ff6a00", border: "none" }}
              onClick={() => handlePayment("nagad")}
            >
              Nagad
            </button>

            <button
              className="btn btn-dark px-4 py-2"
              onClick={() => handlePayment("cash")}
            >
              Cash
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
